export const LanguageList = [
    { value: 'en', label: 'English' },
    { value: 'sk', label: 'Slovenčina' },
    { value: 'hu', label: 'Magyar' },
    { value: 'cz', label: 'Čeština' },
    { value: 'de', label: 'Deutsch' },
    { value: 'ee', label: 'Eesti' },
	{ value: 'it', label: 'Italiano' },
    // { value: 'cn', label: '國語' },
];

export const Languages = LanguageList.map((lang) => lang.value);

export const LanguageMapping = {
    'cs' : 'cz',
};

export function setLanguage(language, languageToSet = null) {
    let lang = language || sessionStorage.getItem('language') || languageToSet ||(navigator.language.split('-').length > 0 ? navigator.language.split('-')[0] : 'en');
    lang = LanguageMapping[lang] || lang;
    if (!Languages.includes(lang)) {
        lang = Languages[0];
    }
    if (!language) {
        let path2nd = window.location.href.split('/gate')[1] || '';
        window.history.pushState(null, '', window.location.origin + '/'+ lang +'/gate' + path2nd);
    } else if (language !== lang) {
        window.history.pushState(null, '', window.location.pathname.replace(language, lang));
    }
    return lang;
}
